export default __webpack_public_path__ + "static/media/milk.90f0915d.svg";